import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  FiFileText, FiShield, FiLogOut, FiX, FiList,
  FiCheckCircle, FiTrendingUp, FiBell, FiUser
} from 'react-icons/fi';
import { motion } from 'framer-motion';
import './Sidebar.css';
import handleStudentLogout from '../Admin-Dashboard-Component/Comman/handleStudentLogout.js';
import StudentVouchersModal from '../Dashboard-Components/StudentVoucherComponent/StudentVouchersModal.js';

const menuItems = [
  { label: 'My Tests', path: '/my-tests', icon: FiList },
  { label: 'Exam Set', path: '/dashboard#upcoming-exams', icon: FiCheckCircle },
  { label: 'Progress Report', path: '/performance-tracker', icon: FiTrendingUp },
  { label: 'Notifications', path: '/student-notifications', icon: FiBell },
  { label: 'Quiz', path: '/dashboard#quiz-section', icon: FiFileText },
  { label: 'My Profile', path: '/settings', icon: FiUser },
  { label: 'Inactive Vouchers', path: '/inactive-vouchers', icon: FiFileText },
  { label: 'Set Vouchers', path: '#set-vouchers', icon: FiFileText, isModal: true }, // ✅ Modal
  { label: 'Terms & Conditions', path: '/terms', icon: FiFileText },
  { label: 'Privacy Policy', path: '/privacy', icon: FiShield },
];

function Sidebar({ sidebarOpen, setSidebarOpen }) {
  const navigate = useNavigate();
  const location = useLocation();
  const currentPath = location.pathname;

  const [voucherModalOpen, setVoucherModalOpen] = useState(false); // ✅ Modal state

  useEffect(() => {
    document.body.style.overflow = sidebarOpen ? 'hidden' : 'auto';
  }, [sidebarOpen]);

  return (
    <>
      <motion.aside
        className={`sidebar ${sidebarOpen ? 'open' : 'closed'}`}
        initial={{ x: -250 }}
        animate={{ x: sidebarOpen ? 0 : -250 }}
        transition={{ type: 'spring', stiffness: 300, damping: 30 }}
      >
        <div className="sidebar-header">
          <motion.span
            className="sidebar-title"
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: sidebarOpen ? 1 : 0, x: sidebarOpen ? 0 : -20 }}
            transition={{ duration: 0.4 }}
          >
            My Dashboard
          </motion.span>

          <motion.div
            initial={{ opacity: 0, rotate: -90 }}
            animate={{ opacity: sidebarOpen ? 1 : 0, rotate: sidebarOpen ? 0 : -90 }}
            transition={{ duration: 0.3 }}
          >
            <FiX
              className="menu-toggle-icon close-icon"
              onClick={() => setSidebarOpen(false)}
            />
          </motion.div>
        </div>

        <ul className="sidebar-menu">
          {menuItems.map(({ label, path, icon: Icon, isModal }) => (
            <li
              key={path}
              className={`sidebar-item ${currentPath === path ? 'active' : ''}`}
              onClick={() => {
                if (isModal) {
                  setVoucherModalOpen(true); // ✅ Open modal
                } else if (path.includes('#')) {
                  const [basePath, hash] = path.split('#');
                  if (currentPath !== basePath) {
                    navigate(basePath, { replace: false });
                    setTimeout(() => {
                      const el = document.getElementById(hash);
                      if (el) el.scrollIntoView({ behavior: 'smooth' });
                    }, 300);
                  } else {
                    const el = document.getElementById(hash);
                    if (el) el.scrollIntoView({ behavior: 'smooth' });
                  }
                } else {
                  navigate(path);
                }
              }}
            >
              <motion.div
                className="sidebar-icon"
                whileHover={{ scale: 1.2, rotate: 5 }}
                transition={{ type: 'spring', stiffness: 300 }}
              >
                <Icon />
              </motion.div>
              <span>{label}</span>
            </li>
          ))}

          <li className="sidebar-item" onClick={() => handleStudentLogout(() => navigate('/'))}>
            <motion.div
              className="sidebar-icon"
              whileHover={{ scale: 1.2, rotate: -5 }}
              transition={{ type: 'spring', stiffness: 300 }}
            >
              <FiLogOut />
            </motion.div>
            <span>Logout</span>
          </li>
        </ul>

        <motion.footer
          className="sidebar-footer"
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4 }}
        >
          <p>📚 Happy Learning!</p>
        </motion.footer>
      </motion.aside>

      {/* ✅ Student Vouchers Modal */}
      <StudentVouchersModal
        studentId={JSON.parse(localStorage.getItem("studentData"))?.id}
        visible={voucherModalOpen}
        onClose={() => setVoucherModalOpen(false)}
        onVoucherActivated={() => console.log("Voucher activated")}
      />
    </>
  );
}

export default Sidebar;
